/* eslint-disable @typescript-eslint/naming-convention */
export enum OffboardTeamMemberWizardStepsActionTypesEnum {
    LOAD_NEXT_STEP = "LOAD_NEXT_STEP",
    LOAD_PREV_STEP = "LOAD_PREV_STEP",
    SET_CONFIRMATION = "SET_CONFIRMATION",
}
